import { observable, action } from "mobx";

const Store = observable(
  {
    query: "",
    advancedFilter: false,
    page: 0,
    count: 0,
    searchValues: {
      payments_processed: false,
    },
    setPage(page) {
      this.page = page;
    },
    setQuery(query) {
      console.log(this.query, query);
      this.query = query;
    },
    setSearchValues(vals) {
      this.searchValues = vals;
    },
    setCount(count) {
      this.count = count;
    },
    toggleAdvancedFilter() {
      this.advancedFilter = !this.advancedFilter;
    },
  },
  {
    setPage: action,
    setQuery: action,
    setCount: action,
    setSearchValues: action,
  }
);

export default Store;
